import { Component, Input } from '@angular/core';
import { contactsProfileContactInformationViewAssigned, contactsProfileCompanyInformationView, contactsInvestigations } from 'src/app/shared/helpers/auth-config/contacts.config';
import { IApiContact, IApiInvestigation, IApiInvestigationBillTo } from 'src/app/shared/modules/graphql/types/types';
import { InvestigationService } from 'src/app/shared/services';

@Component({
  selector: 'app-bill-to-info-popover',
  templateUrl: './bill-to-info-popover.component.html',
  styleUrls: ['./bill-to-info-popover.component.scss']
})
export class BillToInfoPopoverComponent {
  @Input() id: string = '';
  @Input() billTo: IApiContact = null;

    public authConfig = {
    contactsProfileContactInformationViewAssigned,
    contactsProfileCompanyInformationView,
    contactsInvestigations
  }

  public billToPopoverLoading = false;

  public data: IApiInvestigation = null;

  public get additionalBillTos(): IApiInvestigationBillTo[] {
    return (this.data?.InvestigationBillTos || []).filter((item) => item && !item.isPrimary);
  }

  constructor(private investigationService: InvestigationService) {

  }

  handleIconClick() {
    this.billToPopoverLoading = true;
    this.investigationService.getInvestigationByIdForBillToPopover(this.id).subscribe((response) => {
      this.billToPopoverLoading = false;
      this.data = response;
    }, error => {
      this.billToPopoverLoading = false;
    })
  }
}
